import Bugsnag from "@bugsnag/js";
import type { NotifiableError } from "@bugsnag/js";
import {
  BUGSNAG_API_KEY,
  BUGSNAG_ENABLED_RELEASE_STAGES,
} from "@circle-react/config/Settings";

// https://docs.bugsnag.com/platforms/javascript/configuration-options/#autodetecterrors
export const initializeBugsnag = () => {
  const isDesktopApp = !!window.electronAPI;

  const config: any = {
    apiKey: BUGSNAG_API_KEY,
    releaseStage: window.RAILS_ENV,
    enabledReleaseStages: BUGSNAG_ENABLED_RELEASE_STAGES,
    autoDetectErrors: false, // Disable auto detection, hence prevent bugsnag getting spammed.
  };

  if (isDesktopApp) {
    config.metadata = {
      app: {
        platform: "desktop",
        electronVersion: window.electronAPI?.version,
        runningOn: window.electronAPI?.runningOn,
      },
    };
  }

  Bugsnag.start(config);
};

export const notifyBugsnag = (error: NotifiableError) => {
  const isDesktopApp = !!window.electronAPI;

  if (isDesktopApp) {
    Bugsnag.notify(error, event => {
      event.addMetadata("app", {
        platform: "desktop",
        electronVersion: window.electronAPI?.version,
        runningOn: window.electronAPI?.runningOn,
      });
    });
  } else {
    Bugsnag.notify(error);
  }
};

export const addBugsnagBreadcrumb = (breadcrumb: string) => {
  Bugsnag.leaveBreadcrumb(breadcrumb);
};
